import { Tier } from '~services/business/pricing';
import { t } from '@lingui/macro';
import { Membership } from './types';

const imgPaths = {
    plus: '/static/images/pricing/crownPlus.svg',
    premium: '/static/images/pricing/crownPremium.svg',
};

type PricingPlans = Tier.START | Tier.PLUS | Tier.PREMIUM;

enum FEATURE {
    'PAYMENT_LINK' = 'paymentLink',
    'SEVEN_DAYS' = 'sevenDays',
    'UNLIMITED' = 'unlimited',
    'THREE_DAYS' = 'threeDays',
    'OCELLOT' = 'ocellot',
}

const featuresTransMap = {
    [FEATURE.PAYMENT_LINK]: t`global.pricing.features.start.paymentLink`,
    [FEATURE.SEVEN_DAYS]: t`global.pricing.features.start.sevenDays`,
    [FEATURE.UNLIMITED]: t`global.pricing.features.plus.unlimitedPayments`,
    [FEATURE.THREE_DAYS]: t`global.pricing.features.plus.threeDays`,
    [FEATURE.OCELLOT]: t`global.pricing.features.premium.ocellot`,
};

const {
    paymentLink,
    sevenDays,
    unlimited,
    threeDays,
    ocellot,
} = featuresTransMap;

export const memberships: Record<PricingPlans, Membership> = {
    start: {
        heading: 'global.pricing.priceTable.start.heading',
        features: [paymentLink, sevenDays],
        paymentsUpTo: t`global.pricing.features.start.paymentsUpTo`,
        tier: Tier.START,
    },

    plus: {
        heading: 'global.pricing.priceTable.plus.heading',
        headingImg: imgPaths.plus,
        tier: Tier.PLUS,
        pricingYearly: t`global.pricing.yearly`,
        headingAllFrom: t`global.pricing.priceTable.start.heading`,
        features: [unlimited, threeDays],
    },

    premium: {
        heading: 'global.pricing.priceTable.premium.heading',
        headingImg: imgPaths.premium,
        tier: Tier.PREMIUM,
        pricingYearly: t`global.pricing.yearly`,
        headingAllFrom: t`global.pricing.priceTable.plus.heading`,
        features: [ocellot],
    },
};
